/** Small deterministic PRNG so shuffles render identically on server and client. */
export const hashString = (s: string): number => {
    let h = 2166136261

    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i)
        h = Math.imul(h, 16777619)
    }

    return h >>> 0
}

export const mulberry32 = (seed: number) => {
    let a = seed >>> 0

    return () => {
        a = (a + 0x6d2b79f5) >>> 0
        let t = a
        t = Math.imul(t ^ (t >>> 15), t | 1)
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296
    }
}

export const seededShuffle = <T,>(items: T[], seed: string | number): T[] => {
    const rand = mulberry32(typeof seed === 'number' ? seed : hashString(seed))
    const out = [...items]

    for (let i = out.length - 1; i > 0; i--) {
        const j = Math.floor(rand() * (i + 1))
        ;[out[i], out[j]] = [out[j], out[i]]
    }

    return out
}

/** Shuffle that never returns the original order when there is more than one item. */
export const seededDerange = <T,>(items: T[], seed: string | number): T[] => {
    if (items.length < 2) return [...items]

    for (let attempt = 0; attempt < 6; attempt++) {
        const out = seededShuffle(items, `${seed}:${attempt}`)
        if (out.some((x, i) => x !== items[i])) return out
    }

    return [...items.slice(1), items[0]]
}

export const pick = <T,>(items: T[], rand: () => number): T => items[Math.floor(rand() * items.length)]
